import { Injectable } from '@angular/core';
import { HcService } from './hc-service';

@Injectable({
  providedIn: 'root',
})
export class SupportChatService {
  private initialized = false;

  constructor(private hcService: HcService) {}

  public loadSupportChat() {
    if (this.initialized) {
      return;
    }

    const supportChatKey = this.hcService.getHcConfig().config?.supportChatKey;

    if (!supportChatKey) {
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://webchat.voll360.com/voll-webchat.umd.cjs';

    script.onload = () => {
      (window as any).VollWebChat.customInit({
        subdomain: 'portaltelemedicina',
        token: supportChatKey,
      });
      this.initialized = true;
    };

    document.body.appendChild(script);
  }
}
